export const isIE = () => !!window.MSInputMethodContext && !!document.documentMode
  && (window.navigator.userAgent.indexOf('Edge/') === -1);